import React, { FC } from 'react';
import { Platform } from 'react-native';

const AndroidOnly: FC<{ children: React.ReactNode }> = ({ children }) =>
  Platform.OS === 'android' ? (children as any) : null;

export default AndroidOnly;
